import instantsearch from "instantsearch.js";
import {hits, searchBox, refinementList, pagination} from "instantsearch.js/es/widgets";

export default {
  init() {

  },
  finalize() {

    if(!$('body').hasClass('archive')) {

      // Update to Production ID/Key when pushing live
      const options = {
        appId: '6Z7E96AOMV', //dev: D9S80A3AIW
        apiKey: '1bba0902431474069ba87f53963aec2f', //dev: d3b607ad680911a722a475c8584cc158
        indexName: 'wp_searchable_posts', //dev: wp_searchable_posts
        urlSync: {
          mapping: {'q': 's'},
        },
      }

      const search = instantsearch(options);

      // initialize search box
      search.addWidget(
        searchBox({
          container: '#search-box',
          placeholder: 'SEARCH',
        })
      );

      // initialize hits
      search.addWidget(
        hits({
          container: '#hits',
          templates: {
            empty: `
              <div class="py-3">
                <h3 class="m-0 w-md-75">No results found.</h3>
              </div>
            `,
            item: `
            <div class="py-3 pb-5 pr-md-3">
              <h3 class="m-0 w-md-75">{{post_title}}</h3>
              <p class="text-muted m-0">{{ post_type_label }}</p>
              <div>{{{content}}}...</div>
              <a href="{{permalink}}"><button class="btn btn-success btn-taper">Read More</button></a>
            </div>
            `,
          },
          transformData: {
            item: (object) => {
              if (object.custom_content){
                object.content = object.custom_content;
              }
              object.content = object.content.split(" ").splice(0, 45).join(" ");
              return object;
            },
          },
        })
      );

      // initialize filters
      search.addWidget(
        refinementList({
          container: '#refinement-list--posttype',
          attributeName: 'post_type_label',
        })
      );

      search.addWidget(
        refinementList({
          container: '#refinement-list--author',
          attributeName: 'post_author.display_name',
        })
      );

      // initialize pagination
      search.addWidget(
        pagination({
          container: '#pagination',
          maxPages: 5,
          // default is to scroll to 'body', here we disable this behavior
          scrollTo: false,
        })
      );

      search.start();

    }

  },

};



// WEBPACK FOOTER //
// ./scripts/routes/search.js